import api from "../services/api";

// Create Starter Kit Component
export const createStarterKitComponent = async (formData) => {
  try {
    const response = await api.post(
      "/starter-kit-component-management/create",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      console.warn("Unexpected Response:", response);

      return {
        success: false,
        error: "Unexpected response from server",
      };
    }
  } catch (error) {
    console.error(
      "Error creating Starter Kit Component:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to create Starter Kit Component",
    };
  }
};


// Fetch all Starter Kit Components
export const fetchStarterKitComponents = async () => {
  try {
    const response = await api.get(
      "/starter-kit-component-management/list"
    );

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      console.warn("Unexpected Response:", response);

      return {
        success: false,
        error: "Unexpected response from server",
      };
    }
  } catch (error) {
    console.error(
      "Error fetching Starter Kit Components:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch Starter Kit Components",
    };
  }
};


// Update Starter Kit Component
export const updateStarterKitComponent = async (
  componentId,
  payload
) => {
  try {
    const response = await api.put(
      `/starter-kit-component-management/update/${componentId}`,
      payload
    );

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      console.warn("Unexpected Response:", response);

      return {
        success: false,
        error: "Unexpected response from server",
      };
    }
  } catch (error) {
    console.error(
      "Error updating Starter Kit Component:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to update Starter Kit Component",
    };
  }
};


// Delete Starter Kit Component
export const deleteStarterKitComponent = async (
  componentId
) => {
  try {
    const response = await api.delete(
      `/starter-kit-component-management/delete/${componentId}`
    );

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        message:
          "Starter Kit Component deleted successfully",
      };
    } else {
      console.warn("Unexpected Response:", response);

      return {
        success: false,
        error: "Unexpected response from server",
      };
    }
  } catch (error) {
    console.error(
      "Error deleting Starter Kit Component:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to delete Starter Kit Component",
    };
  }
};